import { z } from "zod";

/** NOTE: environment variables marked with NX_PUBLIC_ will have their values from process.env
 *  injected at build-time. All other variables are intended to come from runtime process.env.
 *
 *  If a variable exists in both build-time and runtime, the runtime value takes precedence.
 *
 *  As this is a frontend env schema, keep in mind that the frontend doesn't really have a concept
 *  of runtime process.env, so non NX_PUBLIC_ variables aren't strictly usable in that sense.
 *
 *  NODE_ENV is a special case, injected in frontend builds even without the NX_PUBLIC_ prefix.
 */
export const FrontendEnvironmentSchema = z.object({
  NODE_ENV: z.union([
    z.literal("development"),
    z.literal("production"),
    z.literal("test"),
  ]),
});
